import axios, { API_ENDPOINTS } from 'src/utils/axios';
// check write_access & read_access & full_access
export const getRolePermissions = async (params)=>{
    try {
      const response = await axios({
        method: "get",
        url: API_ENDPOINTS.role.permissions,
        params
      });
      return response.data;
    } catch (error) {
      return false;
    }
  }
  
export const permissions =[
    {
      path:'/dashboard',
      permissionType :'full_access',
      permissionName:'dashboard'
    },
    {
        path:'/dashboard/user',
        permissionType :'full_access',
        permissionName:'user_management'
    },
    {
        path:'/dashboard/user/attendance',
        permissionType :'read_access',
        permissionName:'user_management'
    },
    {
        path:'/dashboard/user/payments',
        permissionType :'read_access',
        permissionName:'user_management'
    },
    {
        path:'/dashboard/user/incentives',
        permissionType :'read_access',
        permissionName:'user_management'
    },
    {
        path:'/dashboard/user/new',
        permissionType :'write_access',
        permissionName:'user_management'
    },
    {
        path:'/dashboard/user/:id/edit',
        permissionType :'write_access',
        permissionName:'user_management'
    },
    {
        path:'/dashboard/role',
        permissionType :'full_access',
        permissionName:'role_management'
    },
    {
        path:'/dashboard/role/new',
        permissionType :'write_access',
        permissionName:'role_management'
    },
    {
        path:'/dashboard/role/:id/edit',
        permissionType :'write_access',
        permissionName:'role_management'
    },
    {
        path:'/dashboard/application/applied',
        permissionType :'read_access',
        permissionName:'application_management'
    },
    {
        path:'/dashboard/application/received',
        permissionType :'read_access',
        permissionName:'received_application_management'
    },
    {
        path:'/dashboard/application/:jobId/:candidateShortUrl',
        permissionType :'read_access',
        permissionName:'application_management'
    },
    {
        path:'/dashboard/talent',
        permissionType :'full_access',
        permissionName:'talent_management'
    },
    {
        path:'/dashboard/talent/new',
        permissionType :'write_access',
        permissionName:'talent_management'
    },
    {
        path:'/dashboard/chat',
        permissionType :'full_access',
        permissionName:'chats'
    },
    {
        path:'/dashboard/chat/:id',
        permissionType :'full_access',
        permissionName:'chats'
    },
    {
        path:'/dashboard/clients',
        permissionType :'full_access',
        permissionName:'client_management'
    },{
        path:'/dashboard/calendar',
        permissionType :'full_access',
        permissionName:'calendar_management'
    },
    {
        path:'/dashboard/invoice',
        permissionType :'full_access',
        permissionName:'invoice_management'
    },
    {
        path:'/dashboard/invoice/new',
        permissionType :'write_access',
        permissionName:'invoice_management'
    },
    {
        path:'/dashboard/invoice/:id/edit',
        permissionType :'write_access',
        permissionName:'invoice_management'
    },
    {
        path:'/dashboard/projects',
        permissionType :'full_access',
        permissionName:'project_management'
    },
    {
        path:'/dashboard/projects/new',
        permissionType :'write_access',
        permissionName:'project_management'
    },
    {
        path:'/dashboard/projects/:id/edit',
        permissionType :'write_access',
        permissionName:'project_management'
    },
    {
        path:'/dashboard/projects/:id',
        permissionType :'read_access',
        permissionName:'project_management'
    },
    {
        path:'/dashboard/documents',
        permissionType :'full_access',
        permissionName:'documents_management'
    },
    {
        path:'/dashboard/proposals/list',
        permissionType :'full_access',
        permissionName:'proposals'
    }
];